var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C12.5615 0 0 12.5615 0 28V45.5C0 51.289 4.711 56 10.5 56H14C15.9355 56 17.5 54.432 17.5 52.5V35C17.5 33.068 15.9355 31.5 14 31.5H7V28C7 16.4185 16.4185 7 28 7C39.5815 7 49 16.4185 49 28V31.5H42C40.0645 31.5 38.5 33.068 38.5 35V52.5C38.5 54.432 40.0645 56 42 56H45.5C51.289 56 56 51.289 56 45.5V28C56 12.5615 43.4385 0 28 0Z",
    fill: "#BA8926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.280953279e7b2f46da95c44a6db3d45a.svg";
export { ForwardRef as ReactComponent };